const criminalOffences = [
  { value: 'Possession of undersized grouper', code_name: 'a01' },
  { value: 'Breach of the Liquor Licence Act', code_name: 'a02' },
  { value: 'Breach of the Shop Licence Act', code_name: 'a03' },
  { value: 'Breach of the Building Permit Act', code_name: 'a04' },
  { value: 'Breach of the Fisheries Act', code_name: 'a05' },
  { value: 'Poss of Housebreaking Implement', code_name: 'a06' },
  { value: 'Breach of the Custom Control Act', code_name: 'a07' },
  { value: 'Hawking', code_name: 'a08' },
  { value: 'Unregistered Cycle', code_name: 'a09' },
  { value: 'Remove a vehicle w/o owner consent', code_name: 'a10' },
  { value: 'Breach of the Immigration Act', code_name: 'a11' },
  { value: 'Breach of the Airport Act', code_name: 'a12' },
  { value: 'Assault', code_name: 'a13' },
  { value: 'Assault with a Deadly Weapon', code_name: 'a14' },
  { value: 'Assault with Dangerous Weapon/Instr', code_name: 'a15' },
  { value: 'Indecent Assault', code_name: 'a16' },
  { value: 'Destroying a Will', code_name: 'a17' },
  { value: 'Convey Letter to Prison', code_name: 'a18' },
  { value: 'Keeping a Gaming House', code_name: 'a19' },
  { value: 'Aid/Abet Premises used for Lottery', code_name: 'a20' },
  { value: 'Negligently Cause Harm', code_name: 'a21' },
  { value: 'Receiving money from a Lottery', code_name: 'a22' },
  { value: 'Gambling', code_name: 'a23' },
  { value: 'Possession of Paper for Lottery', code_name: 'a24' },
  { value: 'Kepping a Brothel', code_name: 'a25' },
  { value: 'Aid and Abet Gambling', code_name: 'a26' },
  { value: 'Gross Indecency', code_name: 'a27' },
  { value: 'Managing a Brothel', code_name: 'a28' },
  { value: 'Act as a Manager of a Brothel', code_name: 'a29' },
  { value: 'Assist a Manager of a Brothel', code_name: 'a30' },
  { value: 'Permit Premises to be used for Prostitution', code_name: 'a31' },
  { value: 'Permit Premises as a Brothel', code_name: 'a32' },
  { value: 'Live off Earnings as a Prostitute', code_name: 'a33' },
  { value: 'Conspiracy to Steal', code_name: 'a34' },
  { value: 'Stealing', code_name: 'a35' },
  { value: 'Aid and Abet Stealing', code_name: 'a36' },
  { value: 'Stealing from a Vehicle', code_name: 'a37' },
  { value: 'Stealing by Control', code_name: 'a38' },
  { value: 'Stealing by Means of Access', code_name: 'a39' },
  { value: 'Stealing by Reason of Office', code_name: 'a40' },
  { value: 'Stealing by Reason of Employment', code_name: 'a41' },
  { value: 'Stealing by Reason of Service', code_name: 'a42' },
  { value: 'Stealing from a Dwelling House', code_name: 'a43' },
  { value: 'Stealing from a Shop', code_name: 'a44' },
  { value: 'Stealing from the Person', code_name: 'a45' },
  { value: 'Stealing from a Vessel', code_name: 'a46' },
  { value: 'Stealing Cattle', code_name: 'a47' },
  { value: 'Fraudulent Breach of Trust', code_name: 'a48' },
  { value: 'Stealing Cultivated Tree', code_name: 'a49' },
  { value: 'Stealing Cultivated Root', code_name: 'a50' },
  { value: 'Stealing Fruit', code_name: 'a51' },
  { value: 'Stealing by Finding', code_name: 'a52' },
  { value: `Remove Vehicle w/o Owner's Consent`, code_name: 'a53' },
  { value: 'Attempted Fraud by False Pretence', code_name: 'a54' },
  { value: 'Dishonestly Receiving', code_name: 'a55' },
  { value: 'Unlawful Possesion', code_name: 'a56' },
  { value: 'Trespassing', code_name: 'a57' },
  { value: 'Causing Damage', code_name: 'a58' },
  { value: 'Malicious Damage', code_name: 'a59' },
  { value: 'Deface Private Property', code_name: 'a60' },
  { value: 'Deface Building', code_name: 'a61' },
  { value: 'Cause Damage to Fence', code_name: 'a62' },
  { value: 'Allow Ferocious Dog to be at Large', code_name: 'a63' },
  { value: 'Keeping a Dog Without Licence', code_name: 'a64' },
  { value: 'Allowing Cattle to Stray', code_name: 'a65' },
  { value: 'Remove Sand from the Beach', code_name: 'a66' },
  { value: 'Depositing Refuse on the Beach', code_name: 'a67' },
  { value: 'Littering', code_name: 'a68' },
  { value: 'Throw Dirt into Harbour', code_name: 'a69' },
  { value: 'Careless Use of Fire', code_name: 'a70' },
  { value: 'Wilful Use of Fire', code_name: 'a71' },
  { value: 'Negligent Use of Fire', code_name: 'a72' },
  { value: 'Imitation of Revenue', code_name: 'a73' },
  { value: 'Imitation of Postal Stamp', code_name: 'a74' },
  { value: 'Issues Initation Postal Stamps', code_name: 'a75' },
  { value: 'Send by Post Imitation Postal Stamp', code_name: 'a76' },
  { value: 'Makes Fictious Stamp', code_name: 'a77' },
  { value: 'Utters Fictious Stamp', code_name: 'a78' },
  { value: 'Sells Fictious Stamp', code_name: 'a79' },
  { value: 'Deals in Fictious Stamp', code_name: 'a80' },
  { value: 'Possession of Fictious Stamp', code_name: 'a81' },
  { value: 'Poss of Instrument to Make F/Stamp', code_name: 'a82' },
  { value: 'Utters Deface Coin', code_name: 'a83' },
  { value: 'Possession of False Coin', code_name: 'a84' },
  { value: 'Drunk in Public Place', code_name: 'a85' },
  { value: 'Drunk and Disorderly', code_name: 'a86' },
  { value: 'Drunk and Incapable', code_name: 'a87' },
  { value: 'Drunk and Violent', code_name: 'a88' },
  { value: 'Unlawfully Carrying Arms', code_name: 'a89' },
  { value: 'Threats of Harm', code_name: 'a90' },
  { value: 'Causing Public Terror', code_name: 'a91' },
  { value: 'Mischievously Frighten Animal', code_name: 'a92' },
  { value: 'Riotous Behaviour', code_name: 'a93' },
  { value: 'Indecent Behaviour', code_name: 'a94' },
  { value: 'Indecent Exposure', code_name: 'a95' },
  { value: 'Disorderly Behaviour ', code_name: 'a96' },
  { value: 'Insulting Behaviour', code_name: 'a97' },
  { value: 'Causing Disturbance', code_name: 'a98' },
  { value: 'Peralt Disturbance', code_name: 'a99' },
  { value: 'Riotous Behaviour in Police Station', code_name: 'a100' },
  { value: 'Indecent Behaviour in Police Station', code_name: 'a101' },
  { value: 'Disorderly Behaviour in Police Station', code_name: 'a102' },
  { value: 'Insulting Behaviour in Police', code_name: 'a103' },
  { value: 'Disturbing the Peace', code_name: 'a104' },
  { value: 'Disturbing Divine Service', code_name: 'a105' },
  { value: 'Disturb Person at Divine Service', code_name: 'a106' },
  { value: 'Molest Person at Divine Service ', code_name: 'a107' },
  { value: 'Disturb Minister at Religious Rite ', code_name: 'a108' },
  { value: 'Make use of Threatening Language', code_name: 'a109' },
  { value: 'Making use of Abusive Language', code_name: 'a110' },
  { value: 'Making use of Abusive Language', code_name: 'a111' },
  { value: 'Acquisition of Proceeds of Crime', code_name: 'a112' },
  { value: 'Money Laundering', code_name: 'a113' },
  { value: 'Violation of Bail Condition', code_name: 'a114' },
  { value: 'Possession of Prohibited Apparatus', code_name: 'a115' },
  { value: 'Engaging Illegal Foreign Fishing Ex', code_name: 'a116' },
  { value: 'Illegel Embarkation', code_name: 'a117' },
  { value: 'Assisting in Illegal Embarkation', code_name: 'a118' },
  { value: 'Possession Component Part Firearm', code_name: 'a119' },
  { value: 'Possession Ammunition Intent Supply ', code_name: 'a120' },
  { value: 'Unlawful Entry', code_name: 'a121' },
  { value: 'Make use of Indecent Language ', code_name: 'a122' },
  { value: 'Breach of Business Licence', code_name: 'a123' },
  { value: 'Voyeurism', code_name: 'a124' },
  { value: 'Forcible Taking with Intent USI', code_name: 'a125' },
  { value: 'Child Pornography', code_name: 'a126' },
  { value: 'Sing Profane Song', code_name: 'a127' },
  { value: 'Sing Indecent Song', code_name: 'a128' },
  { value: 'Sing Obscene Song ', code_name: 'a129' },
  { value: 'Write Profane Matter', code_name: 'a130' },
  { value: 'Write Indecent Matter', code_name: 'a131' },
  { value: 'Write Obscene Matter', code_name: 'a132' },
  { value: 'Sell Profane Literature', code_name: 'a133' },
  { value: 'Sells any Indecent Literature', code_name: 'a134' },
  { value: 'Sell Obscene Literature', code_name: 'a135' },
  { value: 'Distribute Profane Literature', code_name: 'a136' },
  { value: 'Distribute Indecent Literature', code_name: 'a137' },
  { value: 'Distribute Obscene Literature', code_name: 'a138' },
  { value: 'Fighting in Public Place', code_name: 'a139' },
  { value: 'Disturbing Public Peace', code_name: 'a140' },
  { value: 'Discharging Firecrackers in Public', code_name: 'a141' },
  { value: 'Stowaways', code_name: 'a142' },
  { value: 'Throwing Missiles', code_name: 'a143' },
  { value: 'Clean car without a Permit', code_name: 'a144' },
  { value: 'Sells Goods on Highway', code_name: 'a145' },
  { value: 'Solicit Passengers', code_name: 'a146' },
  { value: 'Begging for Ales', code_name: 'a147' },
  { value: 'Selling on Sunday', code_name: 'a148' },
  { value: 'Foul Drinking Heter', code_name: 'a149' },
  { value: 'Keep Putrid Substance', code_name: 'a150' },
  { value: 'In Grave less than 4 feet', code_name: 'a151' },
  { value: 'Cruelty to Animals', code_name: 'a152' },
  { value: 'Working Animals Unfit for Work', code_name: 'a153' },
  { value: 'Unnecessary Pain to Animal', code_name: 'a154' },
  { value: 'Assist Animal Fight', code_name: 'a155' },
  { value: 'Torture Animal to be Killed for Food', code_name: 'a156' },
  { value: 'Torture Bird to be Killed for Food', code_name: 'a157' },
  { value: 'Practising Obeah', code_name: 'a158' },
  { value: 'Withholding Public Money', code_name: 'a159' },
  { value: 'Withholding Public Document', code_name: 'a160' },
  { value: 'Unlawful Possession of Firearms', code_name: 'a161' },
  { value: 'Unlawful Possession of Ammunition', code_name: 'a162' },
  { value: 'Smuggling Goods', code_name: 'a163' },
  { value: 'Insult a Magistrate during Sitting', code_name: 'a164' },
  { value: 'Assault Officer of Magistrate Court', code_name: 'a165' },
  { value: "Misbehave in Magistrate's Court", code_name: 'a166' },
  { value: 'Obstruct Officer of Magistrate Court', code_name: 'a167' },
  { value: 'Disobeying a Summons', code_name: 'a168' },
  { value: 'Breaking a Bond', code_name: 'a169' },
  { value: 'Forfeiture of Bond', code_name: 'a170' },
  { value: 'False Report to Public Officer', code_name: 'a171' },
  { value: 'Assaulting a Peace Officer', code_name: 'a172' },
  { value: 'Obstructing a Peace Officer', code_name: 'a173' },
  { value: 'Resisting a Peace Officer', code_name: 'a174' },
  { value: 'Abet Peace Officer to Desert', code_name: 'a175' },
  { value: 'Aid Mutinous Conduct of Peace Officer', code_name: 'a176' },
  { value: 'Abet Sedition of Peace Officer', code_name: 'a177' },
  { value: 'Take Prohibited Object into Prison', code_name: 'a178' },
  { value: 'Take Prohibited Object out of Prison', code_name: 'a179' },
  { value: 'Aid Escape of Prisoner', code_name: 'a180' },
  { value: 'Interfere with Prisoner', code_name: 'a181' },
  { value: 'Accessory to Breach/Discipline of Prisoner', code_name: 'a182' },
  { value: 'Sending Explosives by Postal Packet', code_name: 'a183' },
  { value: 'Destruction of a Postal Packet', code_name: 'a184' },
  { value: 'Aggravated Assault', code_name: 'a185' },
  { value: 'Causing Harm', code_name: 'a186' },
  { value: 'Hounding', code_name: 'a187' },
  { value: 'Causing Grievous Harm', code_name: 'a188' },
  { value: 'Causing a Maim', code_name: 'a189' },
  { value: 'Causing Dangerous Harm', code_name: 'a190' },
  { value: 'Possession of Poisonous Substance', code_name: 'a191' },
  { value: 'Administration of Noxious Matter', code_name: 'a192' },
  { value: 'Causing Harm by Aggravation', code_name: 'a193' },
  { value: 'Leave Seamen at Sea', code_name: 'a194' },
  { value: 'Rape', code_name: 'a195' },
  { value: 'Incest', code_name: 'a196' },
  { value: 'Attempted Rape', code_name: 'a197' },
  { value: 'Unlawful Sex with Person under 14 Years', code_name: 'a198' },
  { value: 'Unlawful Sex with Person between 14 and 16', code_name: 'a199' },
  {
    value: 'Sexual Intercourse with Person suffering Mental Disability',
    code_name: 'a200',
  },
  { value: 'Buggery', code_name: 'a201' },
  { value: 'Forcible Taking and Detaining', code_name: 'a202' },
  { value: 'Sexual Harassment', code_name: 'a203' },
  { value: 'Assault with Intent to Rape', code_name: 'a204' },
  { value: 'Mandatory Reporting of Sexual Abuse', code_name: 'a205' },
  { value: 'Disclosure of AIDS', code_name: 'a206' },
  { value: 'Pervert Defilement of Young Person', code_name: 'a207' },
  { value: 'Unnatural Sex in Public Place', code_name: 'a208' },
  { value: 'Attempted Stealing', code_name: 'a209' },
  { value: 'Kidnapping', code_name: 'a210' },
  { value: 'Abduction of a Heiress', code_name: 'a211' },
  { value: 'Attempted Incest', code_name: 'a212' },
  { value: 'Sexual Intercourse with Dependent', code_name: 'a213' },
  { value: 'Abatement', code_name: 'a214' },
  { value: 'Conspiracy', code_name: 'a215' },
  { value: 'Stealing Vehicle', code_name: 'a216' },
  { value: 'Attempt to Defile Female under 21', code_name: 'a217' },
  { value: 'Attempt Unlawful Sex with Dependent', code_name: 'a218' },
  { value: 'Conspire to Murder', code_name: 'a219' },
  { value: 'Manslaughter', code_name: 'a220' },
  { value: 'Attempted Murder', code_name: 'a221' },
  { value: 'Manslaughter by Negligence', code_name: 'a222' },
  { value: 'Attempted Suicide', code_name: 'a223' },
  { value: 'Abortion', code_name: 'a224' },
  { value: 'Conceal Body/Child', code_name: 'a225' },
  { value: 'Infanticide', code_name: 'a226' },
  { value: 'Negligent Libel', code_name: 'a227' },
  { value: 'Intentional Libel', code_name: 'a228' },
  { value: 'Fraud by Mail', code_name: 'a229' },
  { value: 'Conviction for Common Thief', code_name: 'a230' },
  { value: 'Extortion', code_name: 'a231' },
  { value: 'Attempt Extortion', code_name: 'a232' },
  { value: 'Conspiracy to Commit Fraud by False Pretence', code_name: 'a233' },
  { value: 'Fraudulent Breach of Trust', code_name: 'a234' },
  { value: 'Conspiracy to Commit Fraud', code_name: 'a235' },
  { value: 'Fraud by False Pretence', code_name: 'a236' },
  { value: 'Fraud as to Insurance', code_name: 'a237' },
  { value: 'Abetment of Fraud', code_name: 'a238' },
  { value: 'Falsification of Accounts', code_name: 'a239' },
  { value: 'Fraudulent Sale of Mortgage', code_name: 'a240' },
  { value: 'Fraudulent Sale of Land', code_name: 'a241' },
  { value: 'Obtain Credit by Fraud', code_name: 'a242' },
  { value: 'Obtain Credit by False Pretence', code_name: 'a243' },
  { value: 'Lend Money by False Pretence', code_name: 'a244' },
  { value: 'Fraud as to Thing Pledged', code_name: 'a245' },
  { value: 'Receiving', code_name: 'a246' },
  { value: 'Receive Money from Lottery', code_name: 'a247' },
  { value: 'Attempted House Breaking', code_name: 'a248' },
  { value: 'Shop Breaking', code_name: 'a249' },
  { value: 'House Breaking', code_name: 'a250' },
  { value: 'Forgery of a Will', code_name: 'a251' },
  { value: 'Burglary', code_name: 'a252' },
  { value: 'Attempted Shop Breaking', code_name: 'a253' },
  { value: 'Entry into a Building by Night', code_name: 'a254' },
  { value: 'Attempted Burglary', code_name: 'a255' },
  { value: 'Forgery of an Official Document', code_name: 'a256' },
  { value: 'Forgery of a Judicial Document', code_name: 'a257' },
  { value: 'Making False Reference', code_name: 'a258' },
  { value: 'Aid and Abet Forgery', code_name: 'a259' },
  { value: 'Forgery', code_name: 'a260' },
  { value: 'Breach of Trust', code_name: 'a261' },
  { value: 'Conspiracy to Commit Forgery', code_name: 'a262' },
  { value: 'Counterfeiting Coin', code_name: 'a263' },
  { value: 'Possession of Counterfeit Money', code_name: 'a264' },
  { value: 'Importing Counterfeit Coin', code_name: 'a265' },
  { value: 'Attempted Arson', code_name: 'a266' },
  { value: 'Arson of a Building', code_name: 'a267' },
  { value: 'Conspiracy to Commit Arson', code_name: 'a268' },
  { value: 'Arson of a Vessel', code_name: 'a269' },
  { value: 'Arson of a Machine', code_name: 'a270' },
  { value: 'Arson of Crop', code_name: 'a271' },
  { value: 'Cause Damage by Fire', code_name: 'a272' },
  { value: 'Damage by Explosion', code_name: 'a273' },
  { value: 'Damage to Construction', code_name: 'a274' },
  { value: 'Damage to Lighthouse', code_name: 'a275' },
  { value: 'Damage to Telegraph', code_name: 'a276' },
  { value: 'Damage to Manufacture', code_name: 'a277' },
  { value: 'Damage to Produce', code_name: 'a278' },
  { value: 'Damage to Cattle', code_name: 'a279' },
  { value: 'Doping of Horses', code_name: 'a280' },
  { value: 'Remove Fish from Private Water', code_name: 'a281' },
  { value: 'Abstracting Electricity', code_name: 'a282' },
  { value: 'Damage to Document', code_name: 'a283' },
  { value: 'Cause Material Damage', code_name: 'a284' },
  { value: 'Attempted Robbery', code_name: 'a285' },
  { value: 'Robbery', code_name: 'a286' },
  { value: 'Conspiracy to Commit Armed Robbery', code_name: 'a287' },
  { value: 'Armed Robbery', code_name: 'a288' },
  { value: 'Attempted Armed Robbery', code_name: 'a289' },
  { value: 'Robbery with Violence', code_name: 'a290' },
  { value: 'Abet to Commit Armed Robbery', code_name: 'a291' },
  { value: 'Sacrilege', code_name: 'a292' },
  { value: 'Steal Apparatus used for Telegraph', code_name: 'a293' },
  { value: 'Stealing a Will', code_name: 'a294' },
  { value: 'Stealing a Codicil', code_name: 'a295' },
  { value: 'Stealing a Mailbag', code_name: 'a296' },
  { value: 'Stealing a Postal Package', code_name: 'a297' },
  { value: 'Stealing from Post Office', code_name: 'a298' },
  { value: 'Stealing from a Mail', code_name: 'a299' },
  { value: 'Export Counterfeit Coins', code_name: 'a300' },
  { value: 'Import Falsified Coin', code_name: 'a301' },
  { value: 'Export Falsified Coin', code_name: 'a302' },
  { value: 'Clipping Coin', code_name: 'a303' },
  { value: 'Common Coiner', code_name: 'a304' },
  { value: 'Possession of Coin Clippers', code_name: 'a305' },
  { value: 'Possession of Forging Instruments', code_name: 'a306' },
  { value: 'Uttering', code_name: 'a307' },
  { value: 'Call Forged Document', code_name: 'a308' },
  { value: 'Possession of Forged Documents', code_name: 'a309' },
  { value: 'Possession of Forged Currency Notes', code_name: 'a310' },
  { value: 'Making a False Statement', code_name: 'a311' },
  { value: 'Making a False Declaration', code_name: 'a312' },
  { value: 'Make False Declaration to Officer U.S.', code_name: 'a313' },
  { value: 'Threats of Grievous Harm in Writing', code_name: 'a314' },
  { value: 'Mutilate Currency Note', code_name: 'a315' },
  { value: 'Abet to Make a False Declaration', code_name: 'a316' },
  { value: 'Conspire to Make a False Declaration', code_name: 'a317' },
  { value: 'Fail to Declare to Officer of U.S.A.', code_name: 'a318' },
  { value: 'Failing to Declare Customs', code_name: 'a319' },
  { value: 'Deface Currency Notes', code_name: 'a320' },
  { value: 'Imitate Currency Notes', code_name: 'a321' },
  { value: 'Name of Printer Currency', code_name: 'a322' },
  { value: 'Make Document by Force', code_name: 'a323' },
  { value: 'Alter Document by Force', code_name: 'a324' },
  { value: 'Cancel Document by Force', code_name: 'a325' },
  { value: 'Forging Hallmark', code_name: 'a326' },
  { value: 'Counterfeit Hallmark', code_name: 'a327' },
  { value: 'Treason', code_name: 'a328' },
  { value: 'Mistreat Prisoner of Treason', code_name: 'a329' },
  { value: 'Setting up an Independent State', code_name: 'a330' },
  { value: 'Armed Force Against the Government', code_name: 'a331' },
  { value: 'Sedition', code_name: 'a332' },
  { value: 'Aiding Escape Prisoner of War', code_name: 'a333' },
  { value: 'Abetment of Mutiny', code_name: 'a334' },
  { value: 'Abatement of Desertion', code_name: 'a335' },
  { value: 'Unlawful Military Training', code_name: 'a336' },
  { value: 'Piracy', code_name: 'a337' },
  { value: 'Taking Unlawful Oath', code_name: 'a338' },
  { value: 'Administering Unlawful Oath', code_name: 'a339' },
  { value: 'Breach of Official Trust', code_name: 'a340' },
  { value: 'Rioting', code_name: 'a341' },
  { value: 'Riot with Offensive Instrument', code_name: 'a342' },
  { value: 'Unlawful Assembly for Riotous Purpose', code_name: 'a343' },
  { value: 'Unlawful Assembly', code_name: 'a344' },
  { value: 'Provocation of Riot', code_name: 'a345' },
  { value: 'Assault Magistrate in Riot', code_name: 'a346' },
  { value: 'Forcible Entry', code_name: 'a347' },
  { value: 'Forcible Detainer', code_name: 'a348' },
  { value: 'Agreeing to Fight with Weapons', code_name: 'a349' },
  { value: 'Challenging to Fight with Weapons', code_name: 'a350' },
  { value: 'Threats of Death', code_name: 'a351' },
  { value: 'Threats of Grievous Harm', code_name: 'a352' },
  { value: 'Threats of Arson in Writing', code_name: 'a353' },
  { value: 'Threats of a Felony in Writing', code_name: 'a354' },
  { value: 'Violence Against a Judge', code_name: 'a355' },
  { value: 'Violence Against a Juror', code_name: 'a356' },
  { value: 'Violence Against a Witness', code_name: 'a357' },
  { value: 'Violence Against Counsel', code_name: 'a358' },
  { value: 'Disturbance of Lawful Assembly', code_name: 'a359' },
  { value: 'Obstruct Public Officer', code_name: 'a360' },
  { value: 'Perjury', code_name: 'a361' },
  { value: 'Fabrication of Evidence', code_name: 'a362' },
  { value: 'Destruction of Public Register', code_name: 'a363' },
  { value: 'Falsification of Public Register', code_name: 'a364' },
  { value: 'Remove Public Register', code_name: 'a365' },
  { value: 'Conceal Public Register', code_name: 'a366' },
  { value: 'Deceit of a Public Officer', code_name: 'a367' },
  { value: 'Bring Fictitious Action', code_name: 'a368' },
  { value: 'Disobey Witness Summons', code_name: 'a369' },
  { value: 'Hindrance of Inquest', code_name: 'a370' },
  { value: 'Disobey Magistrate Order', code_name: 'a371' },
  { value: 'Contempt of Court', code_name: 'a372' },
  { value: 'Breach of Probation Order', code_name: 'a373' },
  { value: 'Resisting Arrest', code_name: 'a374' },
  { value: 'Aiding Persons in Custody to Escape', code_name: 'a375' },
  { value: 'Rescue not for Crime', code_name: 'a376' },
  { value: 'Escape Lawful Custody', code_name: 'a377' },
  { value: 'Willful Escape of a Prisoner', code_name: 'a378' },
  { value: 'Negligent Escape of a Prisoner', code_name: 'a379' },
  { value: 'Compounding a Crime', code_name: 'a380' },
  { value: 'Harbour a Criminal', code_name: 'a381' },
  { value: 'Refuse to Serve in Public Office', code_name: 'a382' },
  { value: 'Falsely Pretend to be a Public Officer', code_name: 'a383' },
  { value: 'Falsely Pretending to be a Juror', code_name: 'a384' },
  { value: 'Corruption by Police Officer', code_name: 'a385' },
  { value: 'Extortion by Public Officer', code_name: 'a386' },
  { value: 'Corruption by Juror', code_name: 'a387' },
  { value: 'Extortion by Juror', code_name: 'a388' },
  { value: 'Destroy Document of Public Office', code_name: 'a389' },
  { value: 'Injure Document of Public Office', code_name: 'a390' },
  { value: 'Falsify Document of Public Office', code_name: 'a391' },
  { value: 'Conceal Document of Public Office', code_name: 'a392' },
  { value: 'Procure Person to Open Postal Package', code_name: 'a393' },
  { value: 'Suffers Postal Package to be Opened', code_name: 'a394' },
  { value: 'Detaining Postal Package', code_name: 'a395' },
  { value: 'Delaying Postal Package', code_name: 'a396' },
  { value: 'Disclosure of Employee Telephone Number', code_name: 'a397' },
  { value: 'Obstruction of Telegraph Service', code_name: 'a398' },
  { value: 'Torture Prisoner by Prison Officer', code_name: 'a399' },
  { value: 'Cruelty to Prisoner by Prison Officer', code_name: 'a400' },
  { value: 'Harm to Prisoner by Prison Officer', code_name: 'a401' },
  { value: 'Corrupting a Public Officer', code_name: 'a402' },
  { value: 'Corrupting a Juror', code_name: 'a403' },
  { value: 'Accept Bribe to Influence Public Officer', code_name: 'a404' },
  { value: 'Accept Bribe to Influence Juror', code_name: 'a405' },
  { value: 'Unlawful Sale of Office', code_name: 'a406' },
  { value: 'Unlawful Purchase of Office', code_name: 'a407' },
  { value: 'Abet Unlawful Sale of Office', code_name: 'a408' },
  { value: 'Abet Unlawful Purchase of Office', code_name: 'a409' },
  { value: 'Causing Damage to any Well', code_name: 'a410' },
  { value: 'Causing Damage to any Spring', code_name: 'a411' },
  { value: 'Causing Damage to any Tank', code_name: 'a412' },
  { value: 'Causing Damage to any Reservoir', code_name: 'a413' },
  { value: 'Corrupts Water of Public Well', code_name: 'a414' },
  { value: 'Corrupts Water of Public Tank', code_name: 'a415' },
  { value: 'Corrupts Water of Public Spring', code_name: 'a416' },
  { value: 'Corrupts Water of Public Reservoir', code_name: 'a417' },
  { value: 'Fouls Water of Public Well', code_name: 'a418' },
  { value: 'Fouls Water of Public Tank', code_name: 'a419' },
  { value: 'Fouls Water of Public Spring', code_name: 'a420' },
  { value: 'Fouls Water of Public Reservoir', code_name: 'a421' },
  { value: 'Bathing from a Public Dock', code_name: 'a422' },
  { value: 'Attempt Obstruct Election by Force', code_name: 'a423' },
  { value: 'Attempt Prevent Election by Force', code_name: 'a424' },
  { value: 'Attempt Disturb Election by Force', code_name: 'a425' },
  { value: 'Forging Voting Paper', code_name: 'a426' },
  { value: 'Falsifying Voting Paper', code_name: 'a427' },
  { value: 'Injuring Voting Paper', code_name: 'a428' },
  { value: 'Destroying Voting Paper', code_name: 'a429' },
  { value: 'Injuring Ballot Box', code_name: 'a430' },
  { value: 'Destroying Ballot Box', code_name: 'a431' },
  { value: 'Injuring Polling Booth', code_name: 'a432' },
  { value: 'Destroying Polling Booth', code_name: 'a433' },
  { value: 'Destroy Anything Used in Election', code_name: 'a434' },
  { value: 'Injuring Anything Used in Election', code_name: 'a435' },
  { value: 'Bigamy', code_name: 'a436' },
  { value: 'False Declaration at Marriage', code_name: 'a437' },
  { value: 'False Pretence of Impediment to Marriage', code_name: 'a438' },
  { value: 'Publication of Blasphemous Document', code_name: 'a439' },
  { value: 'Sale of Blasphemous Document', code_name: 'a440' },
  { value: 'Publication of Obscene Libel', code_name: 'a441' },
  { value: 'Sale of Obscene Libel', code_name: 'a442' },
  { value: 'For Sale of Blasphemous Document', code_name: 'a443' },
  { value: 'For Sale of Obscene Document', code_name: 'a444' },
  { value: 'Permitting Grossly Indecent Act', code_name: 'a445' },
  { value: 'Hindering the Burial of Dead Body', code_name: 'a446' },
  { value: 'Disinters Dead Body', code_name: 'a447' },
  { value: 'Harming Dead Body', code_name: 'a448' },
  { value: 'Dissects Dead Body', code_name: 'a449' },
  { value: 'Failing to Bury Dead Body', code_name: 'a450' },
  { value: 'Publishing False News', code_name: 'a451' },
  { value: 'Selling Unwholesome Food', code_name: 'a452' },
  { value: 'Carrying on Noxious Trade', code_name: 'a453' },
  { value: 'Interfering with Public Rights', code_name: 'a454' },
  { value: 'Carrying on Noisy Business', code_name: 'a455' },
  { value: 'Carrying on Offensive Business', code_name: 'a456' },
  { value: 'Collecting Noxious Material', code_name: 'a457' },
  { value: 'Collecting Offensive Material', code_name: 'a458' },
  { value: 'Keeps Noxious Material', code_name: 'a459' },
  { value: 'Keeps Offensive Material', code_name: 'a460' },
  { value: 'Keeps Animal to Impair Health', code_name: 'a461' },
  { value: 'Keeps Animal to Endanger Health', code_name: 'a462' },
  { value: 'Makes Explosive Matter', code_name: 'a463' },
  { value: 'Keeps Explosive Matter', code_name: 'a464' },
  { value: 'Using Explosive Matter', code_name: 'a465' },
  { value: 'Keep Excavation to Danger of Public', code_name: 'a466' },
  { value: 'Keep Open Pit Danger to the Public', code_name: 'a467' },
  { value: 'Keep Any Structure Danger to Public', code_name: 'a468' },
  { value: 'Work Danger to the Public', code_name: 'a469' },
  { value: 'Keep Animal Danger to the Public', code_name: 'a470' },
  { value: 'Permits Any Animal to be at Large', code_name: 'a471' },
  { value: 'Bribery', code_name: 'a472' },
  { value: 'Attempted Bribery', code_name: 'a473' },
  { value: 'Bribery for Assist Regarding Contract', code_name: 'a474' },
  { value: 'Bribery to Procure Withdrawal of Tender', code_name: 'a475' },
  { value: 'Bribery in Relation to Auctions', code_name: 'a476' },
  { value: 'Bribery by Persons Dealing with Bodies', code_name: 'a477' },
  { value: 'Corrupt Transactions with Agents', code_name: 'a478' },
  { value: 'Breach of Contract', code_name: 'a479' },
  { value: 'Corrupt Inducement', code_name: 'a480' },
  { value: 'Aid and Abet Corrupt Transaction', code_name: 'a481' },
  { value: 'Abetment of Vagrancy', code_name: 'a482' },
  { value: 'Vagrancy', code_name: 'a483' },
  {
    value: 'Possession of Property Derived from Drug Trafficking',
    code_name: 'a484',
  },
  {
    value: 'Living off Proceeds Derived from Drug Trafficking',
    code_name: 'a485',
  },
  { value: 'Cruelty to Children', code_name: 'a486' },
  { value: 'Child Neglect', code_name: 'a487' },
  { value: 'Wilfully Assaults a Child', code_name: 'a488' },
  { value: 'Ill-Treats a Child', code_name: 'a489' },
  { value: 'Abandons a Child', code_name: 'a490' },
  { value: 'Exposes Child to Unnecessary Suffering', code_name: 'a491' },
  { value: 'Permit Child to be Assaulted', code_name: 'a492' },
  { value: 'Permit Child to be Ill-Treated', code_name: 'a493' },
  { value: 'Permit Child to be Neglected', code_name: 'a494' },
  { value: 'Permit Child to be Abandoned', code_name: 'a495' },
  { value: 'Wilfully Neglects Child', code_name: 'a496' },
  { value: 'Cause Child to be Assaulted', code_name: 'a497' },
  { value: 'Cause Child to be Abandoned', code_name: 'a498' },
  { value: 'Cause Child to be Ill-Treated', code_name: 'a499' },
  { value: 'Cause Child to be Neglected', code_name: 'a500' },
  { value: 'Escape Industrial School', code_name: 'a501' },
  { value: 'Escape from Place of Detention', code_name: 'a502' },
  { value: 'Escape on Convey to Industrial School', code_name: 'a503' },
  { value: 'Escape on Convey to Place of Detention', code_name: 'a504' },
  { value: 'Escape on Convey to Hospital', code_name: 'a505' },
  { value: 'Fail to Return after Revocation of Licence', code_name: 'a506' },
  { value: 'Assist Escape from Industrial School', code_name: 'a507' },
  { value: 'Assist Escape from Hospital', code_name: 'a508' },
  { value: 'Harbour Escapee or Young Person', code_name: 'a509' },
  { value: 'Uncontrollable Child', code_name: 'a510' },
  { value: 'Communicate Secret Information', code_name: 'a511' },
  { value: 'Attempt to Communicate Secret Information', code_name: 'a512' },
  { value: 'Receive Secret Information', code_name: 'a513' },
  { value: 'Fail to Furnish Declaration', code_name: 'a514' },
  { value: 'Failure to Prevent a Felony', code_name: 'a515' },
  { value: 'Knowingly Make False Statement', code_name: 'a516' },
  { value: 'Failing to Give Information', code_name: 'a517' },
  { value: 'Mutilate National Flag', code_name: 'a518' },
  { value: 'Cuts National Flag', code_name: 'a519' },
  { value: 'Tears National Flag', code_name: 'a520' },
  { value: 'Burns National Flag', code_name: 'a521' },
  { value: 'Defaces the National Flag', code_name: 'a522' },
  { value: 'Write on National Flag', code_name: 'a523' },
  { value: 'Printing on National Flag', code_name: 'a524' },
  { value: 'Stamping on National Flag', code_name: 'a525' },
  { value: 'Insult National Flag', code_name: 'a526' },
  { value: 'Bring Contempt to National Flag', code_name: 'a527' },
  { value: 'Ridicule National Flag', code_name: 'a528' },
  { value: 'Mutilating Governor General Flag', code_name: 'a529' },
  { value: 'Cuts Governor General Flag', code_name: 'a530' },
  { value: 'Tears Governor General Flag', code_name: 'a531' },
  { value: 'Burns Governor General Flag', code_name: 'a532' },
  { value: 'Defaces Governor General Flag', code_name: 'a533' },
  { value: 'Write on Governor General Flag', code_name: 'a534' },
  { value: 'Printing on Governor General Flag', code_name: 'a535' },
  { value: 'Stamping on Governor General Flag', code_name: 'a536' },
  { value: 'Insults Governor General Flag', code_name: 'a537' },
  { value: 'Bring Contempt to Governor General Flag', code_name: 'a538' },
  { value: 'Ridicule Governor General Flag', code_name: 'a539' },
  { value: 'Mutilating Coat of Arms', code_name: 'a540' },
  { value: 'Cuts Coat of Arms', code_name: 'a541' },
  { value: 'Tears Coat of Arms', code_name: 'a542' },
  { value: 'Burns Coat of Arms', code_name: 'a543' },
  { value: 'Deface Coat of Arms', code_name: 'a544' },
  { value: 'Write on Coat of Arms', code_name: 'a545' },
  { value: 'Printing on Coat of Arms', code_name: 'a546' },
  { value: 'Stamping on Coat of Arms', code_name: 'a547' },
  { value: 'Insult Coat of Arms', code_name: 'a548' },
  { value: 'Bring Contempt to Coat of Arms', code_name: 'a549' },
  { value: 'Ridicule Coat of Arms', code_name: 'a550' },
  { value: 'Use Flag without Authority', code_name: 'a551' },
  { value: 'Use Coat of Arms without Authority', code_name: 'a552' },
  { value: 'Flying Governor General Flag', code_name: 'a553' },
  { value: 'Displaying Governor General Flag', code_name: 'a554' },
  { value: "Fly Prime Minister's Flag", code_name: 'a555' },
  { value: "Displaying Prime Minister's Flag", code_name: 'a556' },
  { value: "Use Prime Minister's Flag", code_name: 'a557' },
  { value: 'Sell Merchandise on Holiday', code_name: 'a558' },
  { value: 'Keep Goods Contrary to Public Holiday Act', code_name: 'a559' },
  { value: 'Expose Goods Contrary to Public Holiday Act', code_name: 'a560' },
  { value: 'Offer for Sale Contrary to Public Holiday Act', code_name: 'a561' },
  {
    value: 'Aid Setting Goods Contrary to Public Holiday Act',
    code_name: 'a562',
  },
  {
    value: 'Aid Keeping Goods Contrary to Public Holiday Act',
    code_name: 'a563',
  },
  {
    value: 'Aid Exposing Goods Contrary to Public Holiday Act',
    code_name: 'a564',
  },
  { value: 'Aid Offering Goods for Sale', code_name: 'a565' },
  {
    value: 'Abets Selling Goods Contrary to Public Holiday Act',
    code_name: 'a566',
  },
  {
    value: 'Abets Keeping Goods Contrary to Public Holiday Act',
    code_name: 'a567',
  },
  {
    value: 'Abets Exposing Goods Contrary to Public Holiday Act',
    code_name: 'a568',
  },
  { value: 'Abets Offering Goods for Sale', code_name: 'a569' },
  { value: 'Keep Open Shop Contrary to Public Holiday Act', code_name: 'a570' },
  { value: 'Aids Opening Shop', code_name: 'a571' },
  { value: 'Abets Opening Shop', code_name: 'a572' },
  {
    value: 'Admits Customer in Shop Contrary to Public Holiday Act',
    code_name: 'a573',
  },
  { value: 'Aids Assisting Customer in Shop', code_name: 'a574' },
  { value: 'Abets Assisting Customer in Shop', code_name: 'a575' },
  { value: 'Purchase Goods Contrary to Public Holiday Act', code_name: 'a576' },
  {
    value: 'Attempt to Purchase Goods Contrary to Public Holiday Act',
    code_name: 'a577',
  },
  {
    value: 'Aids Purchase Goods Contrary to Public Holiday Act',
    code_name: 'a578',
  },
  {
    value: 'Abets Purchase Goods Contrary to Public Holiday Act',
    code_name: 'a579',
  },
  {
    value: 'Aids Attempt to Purchase Goods Contrary to Public Holiday Act',
    code_name: 'a580',
  },
  {
    value: 'Abets Attempt to Purchase Goods Contrary to Public Holiday Act',
    code_name: 'a581',
  },
  { value: 'Forging Passport', code_name: 'a582' },
  { value: 'Unlawful Use of the Telephone', code_name: 'a583' },
  { value: 'Unlawful Use of Electricity', code_name: 'a584' },
  { value: 'Tamper with BEC Apparatus', code_name: 'a585' },
  { value: 'Adjust BEC Installation', code_name: 'a586' },
  { value: 'Reckless Act Concerning BEC Installation', code_name: 'a587' },
  { value: 'Negligent Act BEC Installation', code_name: 'a588' },
  { value: 'Opposition Act BEC Installation', code_name: 'a589' },
  { value: 'Abstracting Energy', code_name: 'a590' },
  { value: 'Dishonestly Consuming Energy', code_name: 'a591' },
  { value: 'Dishonestly Using Energy', code_name: 'a592' },
  { value: 'Alter Index BEC Meter', code_name: 'a593' },
  { value: 'Alter Index BEC Instrument', code_name: 'a594' },
  { value: 'Prevent BEC Meter Recording', code_name: 'a595' },
  { value: 'Prevent BEC Instrument Recording', code_name: 'a596' },
  { value: 'Injuring Meter', code_name: 'a597' },
  { value: 'Injuring Instrument', code_name: 'a598' },
  { value: 'Extinguish Public Lamp', code_name: 'a599' },
  { value: 'Damage Lamp Post', code_name: 'a600' },
  { value: 'Damage Bracket', code_name: 'a601' },
  { value: 'Damage Support to Lamp Post', code_name: 'a602' },
  { value: 'Affix Advertisement to Lamp Post', code_name: 'a603' },
  { value: 'Affix Bill to Lamp Post', code_name: 'a604' },
  { value: 'Affix Paper to Lamp Post', code_name: 'a605' },
  { value: 'Cause Advertisement Affixed to Lamp Post', code_name: 'a606' },
  { value: 'Notice Affixed to Lamp Post', code_name: 'a607' },
  { value: 'Deface Building by BEC', code_name: 'a608' },
  { value: 'Deface Post by BEC', code_name: 'a609' },
  { value: 'Deface Bracket by BEC', code_name: 'a610' },
  { value: 'Deface Other Apparatus Used by BEC', code_name: 'a611' },
  { value: 'Divert Energy Property Course', code_name: 'a612' },
  { value: 'Breaking Supply Line', code_name: 'a613' },
  { value: 'Throw Down Supply Line', code_name: 'a614' },
  { value: 'Damage to Supply Line', code_name: 'a615' },
  { value: 'Break Lamp Post', code_name: 'a616' },
  { value: 'Cause Lamp Post to Fall', code_name: 'a617' },
  { value: 'Throw Down Pole', code_name: 'a618' },
  { value: 'Cause Pole to Fall', code_name: 'a619' },
  { value: 'Damaging Pole', code_name: 'a620' },
  { value: 'Break BEC Apparatus', code_name: 'a621' },
  { value: 'Throw Down BEC Apparatus', code_name: 'a622' },
  { value: 'Cause BEC Apparatus to Fall', code_name: 'a623' },
  { value: 'Damage to BEC Apparatus', code_name: 'a624' },
  { value: 'Obstruct BEC Officer', code_name: 'a625' },
  { value: 'Impede BEC Officer', code_name: 'a626' },
  { value: 'Obstruct Servant of BEC', code_name: 'a627' },
  { value: 'Impede Servant of BEC', code_name: 'a628' },
  { value: 'Fail to Comply with a BEC Order', code_name: 'a629' },
  { value: 'Use Water for Restricted Purposes', code_name: 'a630' },
  { value: 'Fail to Connect Water Supply', code_name: 'a631' },
  { value: 'Fraud or Alter Water Meter', code_name: 'a632' },
  { value: 'Keeping Unsanitized Toilet', code_name: 'a633' },
  { value: 'Fail to Construct House Sewer', code_name: 'a634' },
  { value: 'Injure Water Supply', code_name: 'a635' },
  { value: 'Injure Sewer System', code_name: 'a636' },
  { value: 'Obstruct Minister of Health', code_name: 'a637' },
  { value: 'Driving Past Police Barrier', code_name: 'a638' },
  { value: 'Fail to Suppress Riot', code_name: 'a639' },
  { value: 'Draw Weapon Against Justice of Peace', code_name: 'a640' },
  { value: 'Lift Weapon Against Justice of Peace', code_name: 'a641' },
  { value: 'Offer to Draw Weapon Against Justice of Peace', code_name: 'a642' },
  { value: 'Offer to Lift Weapon Against Justice of Peace', code_name: 'a643' },
  { value: 'Use Violence Towards a Prisoner', code_name: 'a644' },
  { value: 'Pawn Arms', code_name: 'a645' },
  { value: 'Sell Arms', code_name: 'a646' },
  { value: 'Misappropriate Arms', code_name: 'a647' },
  { value: 'Pawn Ammunition', code_name: 'a648' },
  { value: 'Sell Ammunition', code_name: 'a649' },
  { value: 'Misappropriate Ammunition', code_name: 'a650' },
  { value: 'Pawn Accoutrements', code_name: 'a651' },
  { value: 'Sell Accoutrements', code_name: 'a652' },
  { value: 'Misappropriate Accoutrements', code_name: 'a653' },
  { value: 'Pawn Clothing', code_name: 'a654' },
  { value: 'Sell Clothing', code_name: 'a655' },
  { value: 'Misappropriate Clothing', code_name: 'a656' },
  { value: 'Pawn Appointments', code_name: 'a657' },
  { value: 'Sell Appointments', code_name: 'a658' },
  { value: 'Wrongfully Leave Seaman on Shore', code_name: 'a659' },
  { value: 'Pawn Government Property', code_name: 'a660' },
  { value: 'Sell Government Property', code_name: 'a661' },
  { value: 'Misappropriate Government Property', code_name: 'a662' },
  { value: 'Desertion', code_name: 'a663' },
  { value: 'Persuading Police Officer to Desert', code_name: 'a664' },
  { value: 'Procuring Officer to Desert', code_name: 'a665' },
  { value: 'Assist Officer to Desert', code_name: 'a666' },
  { value: 'Attempt to Persuade Officer to Desert', code_name: 'a667' },
  { value: 'Attempt to Procure Officer to Desert', code_name: 'a668' },
  { value: 'Attempt to Assist Officer to Desert', code_name: 'a669' },
  { value: 'Assault a Local Constable', code_name: 'a670' },
  { value: 'Abuse a Local Constable', code_name: 'a671' },
  { value: 'Resist a District Constable', code_name: 'a672' },
  { value: 'Assault a District Constable', code_name: 'a673' },
  { value: 'Abuse a Special Constable', code_name: 'a674' },
  { value: 'Resist a Special Constable', code_name: 'a675' },
  {
    value: 'Withdraw Firearm from Warehouse Without Authority',
    code_name: 'a676',
  },
  { value: 'Possess Firearm Committing an Offence', code_name: 'a677' },
  { value: 'Remove Firearm from Warehouse', code_name: 'a678' },
  { value: 'Use Firearm Without a Licence', code_name: 'a679' },
  { value: 'Introduce Revolver into the Bahamas', code_name: 'a680' },
  { value: 'Possession of Revolver Without Permit', code_name: 'a681' },
  { value: 'Possession of Firearm with Intent', code_name: 'a682' },
  { value: 'Attempt to Bring Revolver to Shore', code_name: 'a683' },
  { value: 'Attempt to Use Revolver in Bahamas', code_name: 'a684' },
  { value: 'Buy Ammunition Without Certificate', code_name: 'a685' },
  { value: 'Acquire Ammunition Without Certificate', code_name: 'a686' },
  { value: 'Buy Firearm Without Certificate', code_name: 'a687' },
  { value: 'Acquire Firearm Without Certificate', code_name: 'a688' },
  { value: 'Possession of Excessive Ammunition', code_name: 'a689' },
  { value: 'Possession of Ammunition Without Permit', code_name: 'a690' },
  { value: 'Possession of a Shortened Firearm', code_name: 'a691' },
  { value: 'Possession of Firearm Without Certificate', code_name: 'a692' },
  { value: 'Possession of a Prohibited Weapon', code_name: 'a693' },
  { value: 'Fail to Comply with Firearm Court', code_name: 'a694' },
  { value: 'Possession of an Imitation Firearm', code_name: 'a695' },
  {
    value: 'Make False Statement to Obtain Firearm Certificate',
    code_name: 'a696',
  },
  { value: 'Possess Imitation Firearm', code_name: 'a697' },
  {
    value: 'Make False Statement to Renew Firearm Certificate',
    code_name: 'a698',
  },
  { value: 'Pawn Firearms Without Certificate', code_name: 'a699' },
  { value: 'Pawn Ammunition Without Certificate', code_name: 'a700' },
  { value: 'Purchase Gun Without Licence', code_name: 'a701' },
  { value: 'Acquire Gun Without Licence', code_name: 'a702' },
  { value: 'Possession of Gun Without Licence', code_name: 'a703' },
  { value: 'Use Gun Without Licence', code_name: 'a704' },
  { value: 'Carry Gun Without Licence', code_name: 'a705' },
  { value: 'Falsify Statement to Procure Gun Licence', code_name: 'a706' },
  { value: 'Willfully Deface Mark on Gun', code_name: 'a707' },
  { value: 'Willfully Obliterate Mark on Gun', code_name: 'a708' },
  { value: 'Willfully Alter Mark on Gun', code_name: 'a709' },
  { value: 'Willfully Counterfeit Mark on Gun', code_name: 'a710' },
  { value: 'Manufacture Firearms Not Registered', code_name: 'a711' },
  { value: 'Deal Firearms not Registered', code_name: 'a712' },
  { value: 'False Statement for Procuring Registration', code_name: 'a713' },
  { value: 'Fails to Surrender Certificate in 1 Month', code_name: 'a714' },
  { value: 'Fail to Register Place of Business', code_name: 'a715' },
  {
    value: 'Falsify Statement to Register Place of Business',
    code_name: 'a716',
  },
  { value: 'Fail to Allow Officer for Firearm Inspection', code_name: 'a717' },
  { value: 'Repair Firearm without Authority', code_name: 'a718' },
  { value: 'Test Firearm without Authority', code_name: 'a719' },
  { value: 'Prove Firearm without Authority', code_name: 'a720' },
  { value: 'Repair Ammunition without Authority', code_name: 'a721' },
  { value: 'Test Ammunition without Authority', code_name: 'a722' },
  { value: 'Prove Ammunition without Authority', code_name: 'a723' },
  { value: 'Under 18 Years Purchase Firearm', code_name: 'a724' },
  { value: 'Under 18 Years Hire a Firearm', code_name: 'a725' },
  { value: 'Under 18 Years Use Firearm', code_name: 'a726' },
  { value: 'Under 18 Years Carry Firearms', code_name: 'a727' },
  { value: 'Under 18 Years Borrow Firearms', code_name: 'a728' },
  { value: 'Under 18 Years Purchase Ammunition', code_name: 'a729' },
  { value: 'Under 18 Years Hire Ammunition', code_name: 'a730' },
  { value: 'Under 18 Years Use Ammunition', code_name: 'a731' },
  { value: 'Under 18 Years Carry Ammunition', code_name: 'a732' },
  { value: 'Under 18 Years Accept Ammunition', code_name: 'a733' },
  { value: 'Under 18 Years Borrow Ammunition', code_name: 'a734' },
  { value: 'Sell Firearm to Person Under 18', code_name: 'a735' },
  { value: 'Let Hire Firearm to Person Under 18', code_name: 'a736' },
  { value: 'Give Firearm to Person Under 18', code_name: 'a737' },
  { value: 'Rent Firearm to Person Under 18', code_name: 'a738' },
  { value: 'Sell Ammunition to Person Under 18', code_name: 'a739' },
  { value: 'Let Hire Ammunition to Person Under 18', code_name: 'a740' },
  { value: 'Give Ammunition to Person Under 18', code_name: 'a741' },
  { value: 'Rent Ammunition to Person Under 18', code_name: 'a742' },
  { value: 'Possession of Prohibited Ammunition', code_name: 'a743' },
  { value: 'Breach of Curfew Order 2020', code_name: 'a744' },
  { value: 'Breach of COVID-19 Order 2020', code_name: 'a745' },
  { value: 'Test Firearm for Drunk', code_name: 'a746' },
  { value: 'Prove Firearm for Drunk', code_name: 'a747' },
  { value: 'Sell Ammunition to Drunk', code_name: 'a748' },
  { value: 'Repair Ammunition for Drunk', code_name: 'a749' },
  { value: 'Test Ammunition for Drunk', code_name: 'a750' },
  { value: 'Prove Ammunition for Drunk', code_name: 'a751' },
  { value: 'Possess Firearm while Bound to Keep Peace', code_name: 'a752' },
  { value: 'Sell Firearms to Prohibited Persons', code_name: 'a753' },
  { value: 'Repair Firearms for Prohibited Persons', code_name: 'a754' },
  { value: 'Test Firearms for Prohibited Persons', code_name: 'a755' },
  { value: 'Prove Firearms for Prohibited Persons', code_name: 'a756' },
  { value: 'Aid and Abet Possession of Firearm', code_name: 'a757' },
  { value: 'Sell Ammunition to Prohibited Person', code_name: 'a758' },
  { value: 'Possession of Firearm to Endanger Life', code_name: 'a759' },
  { value: 'Possession of Firearm to Injure Property', code_name: 'a760' },
  {
    value: 'Possession of Explosives under Suspicious Circumstances',
    code_name: 'a761',
  },
  { value: 'Possession of Firearm after Serving 3 Months', code_name: 'a762' },
  {
    value: 'Possession of Firearm Enabling Another to Endanger Life',
    code_name: 'a763',
  },
  {
    value: 'Possession of Firearm Allowing Another to Endanger Property',
    code_name: 'a764',
  },
  {
    value: 'Possession of Firearm Allowing Another to Endanger Property',
    code_name: 'a765',
  },
  { value: 'Possession of Firearm Putting Another in Fear', code_name: 'a766' },
  {
    value: 'Possession of Firearm with Intent to Resist Arrest',
    code_name: 'a767',
  },
  {
    value: 'Possession of Imitation Firearm to Prevent Arrest',
    code_name: 'a768',
  },
  {
    value: 'Possession of Imitation Firearm to Put in Fear',
    code_name: 'a769',
  },
  {
    value: 'Possession of Imitation Firearm to Resist Arrest',
    code_name: 'a770',
  },
  {
    value: 'Possession of Imitation Firearm to Commit an Offence',
    code_name: 'a771',
  },
  {
    value: 'Possession of Firearm while Trespassing in Building',
    code_name: 'a772',
  },
  { value: 'Possession of Firearm Being Found in Building', code_name: 'a773' },
  { value: 'Shorten Barrel Less Than 20 Inches', code_name: 'a774' },
  { value: 'Convert Imitation Firearm into Firearm', code_name: 'a775' },
  { value: 'Convert Imitation Firearm into Firearm', code_name: 'a776' }, // (duplicate - intentional?)
  { value: 'Fail to Declare Name/Address to Peace Officer', code_name: 'a777' },
  {
    value: 'Fail to Give True Name/Address to Peace Officer',
    code_name: 'a778',
  },
  { value: 'Fail to Handover Firearm to Peace Officer', code_name: 'a779' },
  { value: 'Fail to Handover Ammunition to Peace Officer', code_name: 'a780' },
  { value: 'Explosive Substances Act Violation', code_name: 'a781' },
  { value: 'Unlawful Possession of Explosives', code_name: 'a782' },
  { value: 'Unlawfully Cause Explosion to Endanger Life', code_name: 'a783' },
  {
    value: 'Unlawfully Cause Explosion to Endanger Property',
    code_name: 'a784',
  },
  { value: 'Attempt to Cause Explosion to Endanger Life', code_name: 'a785' },
  { value: 'Keep Explosives to Endanger Life', code_name: 'a786' },
  { value: 'Keep Explosives to Endanger Property', code_name: 'a787' },
  { value: 'Make Explosives to Endanger Life', code_name: 'a788' },
  { value: 'Make Explosives to Endanger Property', code_name: 'a789' },
  { value: 'Conspiracy to Cause an Explosion', code_name: 'a790' },
  {
    value: 'Attempt to Cause Explosion to Endanger Property',
    code_name: 'a791',
  },
  { value: 'Attempt Explosion to Cause Serious Injury', code_name: 'a792' },
  { value: 'Keep Explosive to Cause Serious Injury', code_name: 'a793' },
  { value: 'Make Explosive to Cause Serious Injury', code_name: 'a794' },
  { value: 'Possession of Explosives to Endanger Life', code_name: 'a795' },
  { value: 'Possession of Explosives to Cause Injury', code_name: 'a796' },
  { value: 'Control Explosive Substance to Endanger Life', code_name: 'a797' },
  { value: 'Control Explosive Substance to Cause Injury', code_name: 'a798' },
  {
    value: 'Make Explosives under Suspicious Circumstances',
    code_name: 'a799',
  },
  { value: 'Violence Against a Magistrate', code_name: 'a800' },
  {
    value: 'Control Explosives under Suspicious Circumstances',
    code_name: 'a801',
  },
  { value: 'Supply Money for Breach of Explosives Act', code_name: 'a802' },
  { value: 'Solicit Money for Breach of Explosives Act', code_name: 'a803' },
  { value: 'Provide Premises for Breach of Explosives Act', code_name: 'a804' },
  { value: 'Supply Materials for Breach of Explosives Act', code_name: 'a805' },
  { value: 'Vehicle Used to Breach Explosives Act', code_name: 'a806' },
  { value: 'Ship Used to Breach Explosives Substances Act', code_name: 'a807' },
  { value: 'Boat Used to Breach Explosives Substances Act', code_name: 'a808' }, // (Goat corrected to Boat)
  {
    value: 'Procure Commission of Offence under Explosives Act',
    code_name: 'a809',
  },
  {
    value: 'Counsel Commission of Offence under Explosives Act',
    code_name: 'a810',
  },
  {
    value: 'Aid Commission of Offence under Explosives Act',
    code_name: 'a811',
  },
  {
    value: 'Abet Commission of Offence under Explosives Act',
    code_name: 'a812',
  },
  {
    value: 'Possession of Dangerous Drugs with Intent to Supply',
    code_name: 'a813',
  },
  { value: 'Conspiracy to Import Dangerous Drugs', code_name: 'a814' },
  { value: 'Conspiracy to Possess Dangerous Drugs', code_name: 'a815' },
  { value: 'Conspiracy to Export Dangerous Drugs', code_name: 'a816' },
  { value: 'Conspiracy to Supply Dangerous Drugs', code_name: 'a817' },
  {
    value: 'Conspiracy to Possess Dangerous Drugs with Intent to Supply',
    code_name: 'a818',
  },
  { value: 'Trading in Dangerous Drugs', code_name: 'a819' },
  { value: 'Aiding and Abetting Illegal Entry', code_name: 'a820' },
  { value: 'Illegal Entry', code_name: 'a821' },
  { value: 'Manufacture Dangerous Drugs', code_name: 'a822' },
  { value: 'Selling Dangerous Drugs', code_name: 'a823' },
  { value: 'Dealing Dangerous Drugs', code_name: 'a824' },
  {
    value: 'Allow Premises to be Used for Preparation of Dangerous Drugs',
    code_name: 'a825',
  },
  {
    value: 'Manage Premises Used for Preparation of Dangerous Drugs',
    code_name: 'a826',
  },
  { value: 'Possession of Dangerous Drugs', code_name: 'a827' },
  { value: 'Import Dangerous Drugs', code_name: 'a828' },
  { value: 'Cultivate Marijuana', code_name: 'a829' },
  { value: 'Export Dangerous Drugs', code_name: 'a830' },
  {
    value: 'Possession of Pipe for Smoking Dangerous Drugs',
    code_name: 'a831',
  },
  {
    value: 'Possession of Utensils for Smoking Dangerous Drugs',
    code_name: 'a832',
  },
  { value: 'Smoking Dangerous Drugs', code_name: 'a833' },
  {
    value: 'Frequent Place Used for Smoking Dangerous Drugs',
    code_name: 'a834',
  },
  {
    value: 'Remove Dangerous Drugs from Conveyance into Bahamas',
    code_name: 'a835',
  },
  { value: 'Tamper with Dangerous Drugs in Transit', code_name: 'a836' },
  {
    value: 'Wilfully Open Package of Dangerous Drugs in Transit',
    code_name: 'a837',
  },
  {
    value: 'Wilfully Break Package of Dangerous Drugs in Transit',
    code_name: 'a838',
  },
  {
    value: 'Solicit for Purpose of Selling Dangerous Drugs',
    code_name: 'a839',
  },
  { value: 'Solicit by Misrepresenting Dangerous Drugs', code_name: 'a840' },
  { value: 'Wild Bird Protection Act Violation', code_name: 'a841' },
  { value: 'Killing a Wild Bird', code_name: 'a842' },
  { value: 'Capture a Wild Bird', code_name: 'a843' },
  { value: 'Attempt to Kill a Wild Bird', code_name: 'a844' },
  { value: 'Attempt to Capture a Wild Bird', code_name: 'a845' },
  { value: 'Possession of Firearm for Capturing Wild Bird', code_name: 'a846' },
  { value: 'Possession of Trap for Capturing Wild Bird', code_name: 'a847' },
  { value: 'Possession of Line for Capturing Wild Bird', code_name: 'a848' },
  { value: 'Possession of Snare for Capturing Wild Bird', code_name: 'a849' },
  { value: 'Possession of Net for Capturing Wild Bird', code_name: 'a850' },
  {
    value: 'Possession of Instrument for Capturing Hummingbird',
    code_name: 'a851',
  },
  { value: 'Take Egg or Nest of Wild Bird', code_name: 'a852' },
  { value: 'Take Egg or Deposit of Wild Bird', code_name: 'a853' },
  { value: 'Kill White Crown Pigeon', code_name: 'a854' },
  { value: 'Killing Wild Bird in Reserve', code_name: 'a855' },
  { value: 'Expose Wild Bird Skin or Eggs for Sale', code_name: 'a856' },
  { value: 'Possession of Wild Bird out of Season', code_name: 'a857' },
  { value: 'Possession of an Immature Bird', code_name: 'a858' },
  { value: 'Sale of Immature Bird', code_name: 'a859' },
  { value: 'Export Hummingbird Skin, Eggs, or Feathers', code_name: 'a860' },
  {
    value: 'Attempt to Export Wild Bird Skin, Eggs, or Feathers',
    code_name: 'a861',
  },
  { value: 'Capture Wild Bird not Being a Resident', code_name: 'a862' },
  {
    value: 'Possession of Hummingbird Feather not Being a Resident',
    code_name: 'a863',
  },
  { value: 'Kill More Birds Than Prescribed in One Day', code_name: 'a864' },
  { value: 'Possess More Birds Than Prescribed in One Day', code_name: 'a865' },
  { value: 'Kill Hummingbird Indifferent from Licence', code_name: 'a866' },
  { value: 'Business Licence Act Violation', code_name: 'a867' },
  { value: 'Carry on Business without a Licence', code_name: 'a868' },
  {
    value: 'Fail to Display Business Licence in Conspicuous Place',
    code_name: 'a869',
  },
  {
    value: 'Make False Statement Regarding Business Licence',
    code_name: 'a870',
  },
  { value: 'Liquor Licence Act Violation', code_name: 'a871' },
  { value: 'Sell Liquor without a Licence', code_name: 'a872' },
  { value: 'Proprietary Club Selling Wholesale', code_name: 'a873' },
  { value: 'Wholesale Licence Selling Retail', code_name: 'a874' },
  { value: 'Wholesale Licence Drinking on Premises', code_name: 'a875' },
  { value: 'Sell Liquor to Peace Officer on Duty', code_name: 'a876' },
  { value: 'Fail to Admit Peace Officer', code_name: 'a877' },
  { value: 'Fail to Produce Licence on Demand', code_name: 'a878' },
  { value: 'Permit Premises to be Used as Brothel', code_name: 'a879' },
  { value: 'Sell Liquor to Person under 18 Years', code_name: 'a880' },
  { value: 'Sell Liquor to Drunk Person', code_name: 'a881' },
  { value: 'Abet Intoxicating Liquor without Licence', code_name: 'a882' },
  { value: 'Allow Gambling on a Licensed Premises', code_name: 'a883' },
  {
    value: 'Allow Bad Characters to Frequent Licensed Premises',
    code_name: 'a884',
  },
  { value: 'Sell from an Unlicensed Premises', code_name: 'a885' },
  { value: 'Allow Premises to Open during Unlawful Hours', code_name: 'a886' },
  { value: 'Fail to Put Licence in Conspicuous Place', code_name: 'a887' },
  { value: 'Employ Persons under 18 Years', code_name: 'a888' },
  { value: 'Person under 18 Years Drinking on Premises', code_name: 'a889' },
  { value: 'Exception for Passenger Travel', code_name: 'a890' },
  { value: "Refuse to Obey Magistrate's Order", code_name: 'a891' },
  { value: 'Possess Intoxicating Liquor', code_name: 'a892' },
  { value: 'Possess Liquor for Sale without a Licence', code_name: 'a893' },
  { value: 'Fishery Resources Violation', code_name: 'a894' },
  { value: 'Commercially Fish without a Permit', code_name: 'a895' },
  { value: 'Poaching in Bahamian Waters', code_name: 'a896' },
  { value: 'Take Fish from Restricted or Protected Area', code_name: 'a897' },
  { value: 'Fishing in Protected Area', code_name: 'a898' },
  { value: 'Resisting Fisheries Inspector', code_name: 'a899' },
  { value: 'Obstructing Fisheries Inspector', code_name: 'a900' },
  { value: 'Engage in Foreign Fishing in Exclusive Zone', code_name: 'a901' },
  { value: 'Commercial Fishing by Non-Bahamian', code_name: 'a902' },
  {
    value: 'Non-Bahamian Employed on Bahamian Fishing Vessel',
    code_name: 'a903',
  },
  {
    value: 'Capture Conch for Export within 1 Mile of Main Harbor',
    code_name: 'a904',
  },
  {
    value: 'Destroy Conch for Export within 1 Mile of Main Harbor',
    code_name: 'a905',
  },
  {
    value: 'Kill Conch for Export within 1 Mile of Main Harbor',
    code_name: 'a906',
  },
  {
    value: 'Take Conch for Export within 1 Mile of Main Harbor',
    code_name: 'a907',
  },
  { value: 'Capture Conch for Export in Mixes of Harbor', code_name: 'a908' },
  { value: 'Destroy Conch for Export in Mixes of Harbor', code_name: 'a909' },
  { value: 'Kill Conch for Export in Mixes of Harbor', code_name: 'a910' },
  {
    value: 'Obstruct Inspector under Agriculture and Fisheries Act',
    code_name: 'a911',
  },
  {
    value: 'Resist Inspector under Agriculture and Fisheries Act',
    code_name: 'a912',
  },
  { value: 'Fish for Crawfish without Measuring Gauge', code_name: 'a913' },
  { value: 'Possession of Undersized Crawfish', code_name: 'a914' },
  { value: 'Export Crawfish Less Than 3 3/4 Inches', code_name: 'a915' },
  { value: 'Export Crawfish without a Licence', code_name: 'a916' },
  { value: 'Spear Crawfish Except for Fresh Food', code_name: 'a917' },
  { value: 'Harpoon Crawfish Except for Fresh Food', code_name: 'a918' },
  { value: 'Possess Crawfish Carrying Eggs', code_name: 'a919' },
  { value: 'Possession of Spawning Crawfish', code_name: 'a920' },
  { value: 'Construct Kraal for Crawfish', code_name: 'a921' },
  { value: 'Offer for Sale Uninspected Crawfish', code_name: 'a922' },
  { value: 'Selling Uninspected Turtle', code_name: 'a923' },
  { value: 'Fish for Crawfish Tail Less Than 5 oz', code_name: 'a924' },
  { value: 'Take Crawfish Tail Less Than 5 oz', code_name: 'a925' },
  { value: 'Capture Crawfish Tail Less Than 5 oz', code_name: 'a926' },
  { value: 'Possess Crawfish Tail Less Than 5 oz', code_name: 'a927' },
  { value: 'Sell Crawfish Tail Less Than 5 oz', code_name: 'a928' },
  { value: 'Expose for Sale Crawfish Tail Less Than 5 oz', code_name: 'a929' },
  { value: 'Offer for Sale Crawfish Tail Less Than 5 oz', code_name: 'a930' },
  { value: 'Fish for Crawfish Less Than 1 lb', code_name: 'a931' },
  { value: 'Take Crawfish Less Than 1 lb', code_name: 'a932' },
  { value: 'Capture Crawfish Less Than 1 lb', code_name: 'a933' },
  { value: 'Destroy Crawfish Less Than 1 lb', code_name: 'a934' },
  { value: 'Possess Crawfish Less Than 1 lb', code_name: 'a935' },
  { value: 'Sell Crawfish Less Than 1 lb', code_name: 'a936' },
  { value: 'Expose for Sale Crawfish Less Than 1 lb', code_name: 'a937' },
  { value: 'Offer for Sale Crawfish Less Than 1 lb', code_name: 'a938' },
  { value: 'Take Crawfish Less Than 3 3/8 Inches', code_name: 'a939' },
  { value: 'Destroy Crawfish Less Than 3 3/8 Inches', code_name: 'a940' },
  { value: 'Possess Crawfish Less Than 3 3/8 Inches', code_name: 'a941' },
  { value: 'Sell Crawfish Less Than 3 3/8 Inches', code_name: 'a942' },
  {
    value: 'Expose for Sale Crawfish Less Than 3 3/8 Inches',
    code_name: 'a943',
  },
  {
    value: 'Offer for Sale Crawfish Less Than 3 3/8 Inches',
    code_name: 'a944',
  },
  { value: 'Sell Live Crawfish in Closed Season', code_name: 'a945' },
  {
    value: 'Expose for Sale Live Crawfish in Closed Season',
    code_name: 'a946',
  },
  { value: 'Offer for Sale Live Crawfish in Closed Season', code_name: 'a947' },
  { value: 'Buy Fresh Crawfish in Closed Season', code_name: 'a948' },
  { value: 'Sell Fresh Crawfish in Closed Season', code_name: 'a949' },
  {
    value: 'Expose for Sale Fresh Crawfish in Closed Season',
    code_name: 'a950',
  },
  {
    value: 'Offer for Sale Fresh Crawfish in Closed Season',
    code_name: 'a951',
  },
  { value: 'Fish for Crawfish Less Than 3 3/8 Inches', code_name: 'a952' },
  { value: 'Take Conch for Export 1 Mile off Andros', code_name: 'a953' },
  { value: 'Capture Conch for Export 1 Mile off Andros', code_name: 'a954' },
  { value: 'Destroy Conch for Export 1 Mile off Andros', code_name: 'a955' },
  { value: 'Kill Conch for Export 1 Mile off Andros', code_name: 'a956' },
  { value: 'Take Conch for Export 1 Mile off Grand Bahama', code_name: 'a957' },
  {
    value: 'Capture Conch for Export 1 Mile off Grand Bahama',
    code_name: 'a958',
  },
  {
    value: 'Destroy Conch for Export 1 Mile off Grand Bahama',
    code_name: 'a959',
  },
  { value: 'Kill Conch for Export 1 Mile off Grand Bahama', code_name: 'a960' },
  { value: 'Take Conch for Export within Main Harbor', code_name: 'a961' },
  { value: 'Driving without Third Party Insurance', code_name: 'a962' },
  { value: 'Driving while Disqualified', code_name: 'a963' },
  { value: 'Fail to Give Information', code_name: 'a964' },
  { value: 'Deface Number Plate', code_name: 'a965' },
  { value: 'Obscuring Number Plate', code_name: 'a966' },
  { value: 'Forging Certificate of Insurance', code_name: 'a967' },
  { value: 'Forging Number Plate', code_name: 'a968' },
  { value: 'Use Unregistered Vehicle', code_name: 'a969' },
  { value: 'Fail to Submit Vehicle for Inspection', code_name: 'a970' },
  { value: 'Permit Use of Unregistered Vehicle', code_name: 'a971' },
  { value: "Drive without Driver's Licence", code_name: 'a972' },
  { value: 'Employ a Driver to Drive without Licence', code_name: 'a973' },
  { value: 'Driving while Disqualified from Driving', code_name: 'a974' },
  { value: 'Driving while Licence is Suspended', code_name: 'a975' },
  { value: 'Speeding', code_name: 'a976' },
  { value: 'Abetting Speeding', code_name: 'a977' },
  { value: 'Kill in Course of Dangerous Driving', code_name: 'a978' },
  { value: 'Kill in Course of Reckless Driving', code_name: 'a979' },
  { value: 'Reckless Driving', code_name: 'a980' },
  { value: 'Dangerous Driving', code_name: 'a981' },
  { value: 'Drive without Due Care and Attention', code_name: 'a982' },
  { value: 'Drive under Influence of Liquor', code_name: 'a983' },
  { value: 'Drive under Influence of Drugs', code_name: 'a984' },
  { value: 'Drive a Defective Vehicle', code_name: 'a985' },
  { value: "Drive Vehicle without Owner's Consent", code_name: 'a986' },
  { value: 'Fail to Stop at Request of Police', code_name: 'a987' },
  { value: 'Refuse to Give Name and Address', code_name: 'a988' },
  { value: 'Fail to Give Information to Other Driver', code_name: 'a989' },
  {
    value: 'Vehicle not Being a Taxi Parked in Taxi Station',
    code_name: 'a990',
  },
  { value: 'Vehicle not Being a Taxi Plying for Hire', code_name: 'a991' },
  {
    value: 'Public Service Driver Fail to Comply with Lawful Direction',
    code_name: 'a992',
  },
  { value: 'Fail to have Fare Displayed in Taxi', code_name: 'a993' },
  { value: 'Tinted Glass Violation', code_name: 'a994' },
  { value: 'Fail to Give Name and Address', code_name: 'a995' },
  { value: 'Leave Vehicle Engine Running', code_name: 'a996' },
  { value: 'Obstructing Traffic', code_name: 'a997' },
  { value: 'Passing at an Intersection', code_name: 'a998' },
  { value: 'Passing on Top of a Hill', code_name: 'a999' },
  { value: 'Passing on a Curve', code_name: 'a1000' },
  { value: 'Drive without Licence Plates', code_name: 'a1001' },
  { value: 'Driving on Sidewalk', code_name: 'a1002' },
  { value: 'Insecure Load', code_name: 'a1003' },
  { value: 'Fail to Obey Traffic Signal', code_name: 'a1004' },
  { value: 'Failing to Obey Traffic Sign', code_name: 'a1005' },
  { value: 'Fail to Obey Direction', code_name: 'a1006' },
  { value: 'Fraudulent Use of Licence Disc', code_name: 'a1007' },
  { value: 'Taking Preparatory Steps to Export', code_name: 'a1008' },
  { value: 'Murder', code_name: 'a1009' },
  { value: 'Resisting Arrest for Crime', code_name: 'a1010' },
]

export default criminalOffences
